import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconPuzzle = ({
  title = "Puzzle",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#F77769" cx="32" cy="32" r="32" />
      <path
        d="M22 28a5 5 0 010 10v4c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V24c0-.6-.4-1-1-1h-5v-.8a4 4 0 00-8 0v.8h-5a1 1 0 00-1 1v4z"
        stroke="#FFF"
        strokeWidth="2"
      />
    </g>
  </Svg.Icon>
)

export default IconPuzzle
